function get(name) {
  const parts = document.cookie.split(/;\s*/);
  const n = `${name}=`;
  const cookieValue = parts.find((part) => {
    return part.startsWith(n);
  });
  if (cookieValue) {
    return decodeURIComponent(cookieValue.replace(n, ""));
  }
  return void 0;
}

export { get as g };
/*                                 */
